// version 2024-11-14
var videoIdJSON = {};
var subscriptionSignup = document.createElement('div');
subscriptionSignup.innerHTML = ('<p>Your membership does not include this video.</p>');

// define an object to hold the videos
var videos = [];

$(document).ready(function() {

// first we want to see if there are any vimeoID elements on the page

const videosFromPage = document.querySelectorAll('[data-vimeoID]');
console.log(videosFromPage);
// if there are videos to be loaded from the page, we'll build the playlist from there
  if ( videosFromPage.length > 0 ) {
    console.log("there are videos to be loaded on the page");
    for (let i = 0; i < videosFromPage.length; i++) {
      const vimeoID = videosFromPage[i].getAttribute('data-vimeoID');
      videos[`${i}`] = vimeoID;
    }
    // Now create your final object
    videoIdJSON = {
      "videoIDs": videos
    };
    console.log(JSON.stringify(videoIdJSON));
    getVideoDetails();
    //loadFirstVideo();
  } else {
    // since there are no videos to be loaded on the page, we will check to see if there is anything in the query strings
    // Get the query string from the current URL
    var params = window.location.search;
    
    // Remove the leading '?'
    params = params.substring(1);

    // Split the parameters into an array of 'key=value' strings
    var splitParams = params.split('&');
    
    // Initialize an empty array to hold your video IDs
    var videoIDs = [];
    
    // Loop through the split parameters
    for (var i = 0; i < splitParams.length; i++) {
      // Split each 'key=value' string into [key, value]
      var splitParam = splitParams[i].split('=');
      
      // The key (the parameter name) is the first element in the splitParam array
      var key = splitParam[0];
      
      // The value (the video ID) is the second element in the splitParam array
      var value = splitParam[1];
    
      // If the key starts with 'v', add the value to the videoIDs array
      if (key.startsWith('v')) {
        videoIDs.push(value);
      } else if ( key.startsWith('title')) {
        $('#playlist_title').text(decodeURIComponent(value));

      }
    }

    // Now create your final object
    videoIdJSON = {
      "videoIDs": videoIDs
    };
    console.log(JSON.stringify(videoIdJSON));
    getVideoDetails();
  }
});
$('.login-button').click(function(){
  // Get the current URL
const currentURL = window.location.href;

// URL encode the current URL
const encodedURL = encodeURIComponent(currentURL);
  window.location = "../account/login?checkout_url="+encodedURL;
});



var videoData = [];
var firstVideo = "";
// get video details
function getVideoDetails() {
  fetch('https://mmel2ilhgi4ztwzdkp6jt6xry40wlbca.lambda-url.us-west-2.on.aws/', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(videoIdJSON)
  })
  .then(response => response.json())
  .then(data => {
      console.log(data);  // keep the log if you want
      firstVideo = data[0].id;
      console.log(firstVideo);
      videoData = data;
      createPlaylist(data);  // call createPlaylist with data
      loadVideo(firstVideo);
      
  })
  .catch((error) => {
      console.error('Error:', error);
  });
}

// function to create the playlist
function createPlaylist(data){
  var playlistDiv = document.getElementById('playlist');
        
  data.forEach(function(video) {
      console.log("Adding video to playlist");
      var videoDiv = document.createElement('div');
      videoDiv.id = video.id;
      videoDiv.classList.add('video-wrapper');
      videoDiv.classList.add('span-4');
      videoDiv.classList.add('auto');
      videoDiv.classList.add("playlist-item");
      
      var thumbnail = document.createElement('img');
      thumbnail.src = video.thumbnail;
      thumbnail.classList.add("vimeo-thumbnail");
      videoDiv.appendChild(thumbnail);
           
      var title = document.createElement('h2');
      title.textContent = video.title;
      title.classList.add("playlist-item-title");
      videoDiv.appendChild(title);
      
      playlistDiv.appendChild(videoDiv);
  });
}



// load a video into the player
function loadVideo(id) {
  console.log("Loading video ID "+ id);
  console.log("This is the customer tags array" + customerTags);
  let index = videoData.findIndex(video => video.id === id);
  const iframe = document.createElement('iframe');
  // Set the iframe attributes
  iframe.setAttribute('src', `https://player.vimeo.com/video/`+id+`?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`);
  iframe.setAttribute('width', '640');
  iframe.setAttribute('height', '360');
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
  iframe.setAttribute('allowfullscreen', '');
  iframe.setAttribute('style', 'position:absolute;top:0;left:0;width:100%;height:100%;');
  iframe.setAttribute('id', 'player-iframe');
  // Get the video container element
  const container = document.getElementById('video-player');
  // nuke the old stuff
  if (container) {
    container.innerHTML = "";
  }
  // let's check to see if the video tags match the customer tags
  console.log(videoData[index].tags);
  const videoTags = videoData[index].tags.map(tag => tag.toLowerCase());
  // Convert customerTags to lowercase before comparison
  if (customerTags ) {
  const lowerCaseCustomerTags = customerTags.map(tag => tag.toLowerCase());
  const hasMatchingTags = lowerCaseCustomerTags.some(customerTag => 
        videoTags.includes(customerTag)
    );
  if (hasMatchingTags) {
    container.appendChild(iframe);
    console.log("next video loaded");
    const player = new Vimeo.Player(iframe);
    player.on('play', function() {
      console.log('played the video!');
    });
    player.play();
    $('#video-title').text(videoData[index].title);
    //var description = videoData[index].description.replace(/\n/g, '<br>');
    //$('#video-description').html(description);
    const playlistLength = videoData.length;
    console.log("The playlist has this many tracks: "+playlistLength);
    if ( index != playlistLength) {
      var nextIndex = index + 1;
      var nextId = videoData[nextIndex].id;
      player.on('ended', function() {
       loadVideo(nextId)
      });
    }
  } else {
    container.appendChild(subscriptionSignup);
    $('#video-title').text(videoData[index].title);
    var description = videoData[index].description.replace(/\n/g, '<br>');
    $('#video-description').html(description);
  }
  }
  // Check to see if this is a free video 
  const isFreeVideo = videoTags.includes("tier1");
    // Check for matching tags
  
  if (isFreeVideo) {
    console.log("This video is free");
    $('.force-login').hide();
    if (container) {
      container.appendChild(iframe);
    }
    console.log("next video loaded");
    const player = new Vimeo.Player(iframe);
    player.on('play', function() {
      console.log('played the video!');
    });
    player.play();
    $('#video-title').text(videoData[index].title);
    //var description = videoData[index].description.replace(/\n/g, '<br>');
    //$('#video-description').html(description);
    const playlistLength = videoData.length;
    console.log("The playlist has this many tracks: "+playlistLength);
    if ( index != playlistLength) {
      var nextIndex = index + 1;
      var nextId = videoData[nextIndex].id;
      player.on('ended', function() {
       loadVideo(nextId)
      });
    }
  }
  
  
  
  
  
}



$(document).ready(function() {
  console.log("loaded");
  $("body").on('click', '.playlist-item', function(event) {
    console.log("click");
    var id = $(this).attr('id');
    loadVideo(id);
  });
});